// icons/AlignLeft.tsx
import * as React from "react";
var SvgAlignLeft = (props) => /* @__PURE__ */ React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M280 48H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h272a8 8 0 0 0 8-8V56a8 8 0 0 0-8-8zm160 384H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h432a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zM280 304H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h272a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zm160-128H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h432a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8z"
}));
var AlignLeft_default = SvgAlignLeft;

// icons/Bell.tsx
import * as React2 from "react";
var SvgBell = (props) => /* @__PURE__ */ React2.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512",
  ...props
}, /* @__PURE__ */ React2.createElement("path", {
  d: "M256 32v19.2c73 14.83 128 79.4 128 156.8v18.8c0 47.1 17.3 92.4 48.5 127.6l7.4 8.3c8.4 9.5 10.5 22.9 5.3 34.4S428.6 416 416 416H32c-12.6 0-24.029-7.4-29.191-18.9-5.162-11.5-3.097-24.9 5.275-34.4l7.416-8.3C46.74 319.2 64 273.9 64 226.8V208c0-77.4 54.1-141.97 128-156.8V32c0-17.67 14.3-32 32-32s32 14.33 32 32zm-32 480c-17 0-33.3-6.7-45.3-18.7S160 464.1 160 448h128c0 16.1-6.7 33.3-18.7 45.3S240.1 512 224 512z"
}));
var Bell_default = SvgBell;

// icons/BrokenLink.tsx
import * as React3 from "react";
var SvgBrokenLink = (props) => /* @__PURE__ */ React3.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 285 123",
  stroke: "#000",
  ...props
}, /* @__PURE__ */ React3.createElement("path", {
  stroke: "inherit",
  strokeWidth: 8,
  fill: "none",
  d: "M120.6 24.3 97 33.5c-8.5 2.5-21.4 5-17.5 19.3 3 10.8 17.5 6.6 32 6.6h72.3c3.7 0 11.3-1.3 12.1-6.6 1-6.6 3.2-9.3-12.1-16.4L152 24.3"
}), /* @__PURE__ */ React3.createElement("path", {
  stroke: "inherit",
  strokeWidth: 8,
  fill: "none",
  d: "M79.6 23a726.4 726.4 0 0 0-63 20.8c-10.4 5-14.8 18-10.4 34.3a29 29 0 0 0 25.9 21.4c6.7.3 57.2-13.2 67-21.4 9.8-8.2 12.5-20.7 7.4-37a25.6 25.6 0 0 0-27-18.1ZM260 42.1a743 743 0 0 0-64-17.9c-11.4-1.6-22.3 6.8-27.7 22.7a29 29 0 0 0 9.5 32.2c5.4 4 54.9 21 67.6 19.7 12.6-1.4 21.8-10.2 26.7-26.5A25.6 25.6 0 0 0 260 42Z"
}));
var BrokenLink_default = SvgBrokenLink;

// icons/Calendar.tsx
import * as React4 from "react";
var SvgCalendar = (props) => /* @__PURE__ */ React4.createElement("svg", {
  viewBox: "0 0 14 14",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React4.createElement("path", {
  d: "M11.813 1.75H10.5V.328A.353.353 0 0 0 10.172 0h-.219a.332.332 0 0 0-.328.328V1.75h-5.25V.328A.353.353 0 0 0 4.047 0h-.219A.332.332 0 0 0 3.5.328V1.75H2.187c-.738 0-1.312.602-1.312 1.313v9.624c0 .739.574 1.313 1.313 1.313h9.624c.711 0 1.313-.574 1.313-1.313V3.063a1.33 1.33 0 0 0-1.313-1.313Zm-9.626.875h9.626a.47.47 0 0 1 .437.438v1.312H1.75V3.062a.45.45 0 0 1 .438-.437Zm9.626 10.5H2.187a.432.432 0 0 1-.437-.438V5.25h10.5v7.438a.45.45 0 0 1-.438.437ZM4.921 8.75a.332.332 0 0 0 .328-.328V7.328A.353.353 0 0 0 4.922 7H3.828a.332.332 0 0 0-.328.328v1.094c0 .191.137.328.328.328h1.094Zm2.625 0a.332.332 0 0 0 .328-.328V7.328A.353.353 0 0 0 7.547 7H6.453a.332.332 0 0 0-.328.328v1.094c0 .191.137.328.328.328h1.094Zm2.625 0a.333.333 0 0 0 .328-.328V7.328A.353.353 0 0 0 10.172 7H9.078a.332.332 0 0 0-.328.328v1.094c0 .191.137.328.328.328h1.094Zm-2.625 2.625a.332.332 0 0 0 .328-.328V9.953a.353.353 0 0 0-.328-.328H6.453a.332.332 0 0 0-.328.328v1.094c0 .191.137.328.328.328h1.094Zm-2.625 0a.332.332 0 0 0 .328-.328V9.953a.353.353 0 0 0-.328-.328H3.828a.332.332 0 0 0-.328.328v1.094c0 .191.137.328.328.328h1.094Zm5.25 0a.332.332 0 0 0 .328-.328V9.953a.353.353 0 0 0-.328-.328H9.078a.332.332 0 0 0-.328.328v1.094c0 .191.137.328.328.328h1.094Z"
}));
var Calendar_default = SvgCalendar;

// icons/CartCircle.tsx
import * as React5 from "react";
var SvgCartCircle = (props) => /* @__PURE__ */ React5.createElement("svg", {
  viewBox: "0 0 80 80",
  fill: "#262626",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React5.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M37.226.05C28.773.67 20.92 3.835 14.364 9.265c-1.222 1.013-4.089 3.88-5.076 5.076-4.36 5.286-7.192 11.208-8.514 17.807-2.113 10.542.149 21.626 6.213 30.445a41.42 41.42 0 0 0 8.316 8.874c5.553 4.4 12.513 7.317 19.596 8.212 12.15 1.536 24.222-2.477 32.891-10.932 4.724-4.607 8.017-9.792 10.098-15.9 4.34-12.738 1.89-27.072-6.42-37.566-1.538-1.943-3.893-4.393-5.623-5.85-6.215-5.232-13.61-8.38-21.76-9.263-1.42-.154-5.42-.221-6.859-.116Zm5.602 2.04c4.91.387 9.477 1.62 13.79 3.72 11.503 5.604 19.453 16.678 21.064 29.341a39.912 39.912 0 0 1 0 9.674c-.769 6.042-3.04 11.936-6.511 16.89-5.95 8.495-14.984 14.164-25.183 15.806-3.282.528-7.536.591-10.844.16-11.552-1.505-21.746-8.19-27.754-18.202-4.358-7.263-6.13-15.8-5.062-24.392.62-4.995 2.425-10.194 5.062-14.59A38.059 38.059 0 0 1 37.022 2.095c1.207-.097 4.598-.1 5.806-.005ZM14.943 21.003a1.29 1.29 0 0 0-.343.523c-.08.266-.07.359.06.622.084.17.257.385.384.478.22.161.35.17 3.049.192 2.321.02 2.85.045 3.003.144.246.161.582.795.738 1.39.23.883 1.509 7.81 3.64 19.719 1.305 7.3 1.333 7.416 1.888 7.884.36.303.936.577 1.438.684.31.065 4.244.091 13.921.091 13.385 0 13.491-.002 13.76-.165.33-.202.537-.657.467-1.03-.063-.34-.446-.727-.784-.795-.143-.028-6.254-.052-13.58-.052-12.516 0-13.336-.009-13.604-.143l-.286-.143-.507-2.777c-.278-1.527-.508-2.859-.51-2.96l-.004-.182 13.166-.021 13.166-.022.484-.184c1.067-.407 1.9-1.126 2.33-2.009.148-.304.666-2.067 1.313-4.464a957.126 957.126 0 0 1 1.558-5.718c.27-.966.565-2.03.657-2.364.23-.831.184-1.752-.116-2.338-.262-.513-.757-.968-1.358-1.25l-.459-.215-17.083-.021-17.085-.021-.041-.183c-.023-.1-.13-.606-.239-1.123-.238-1.14-.446-1.71-.857-2.345-.377-.584-.916-1.042-1.474-1.255-.382-.145-.65-.157-3.428-.157h-3.014l-.25.21Zm43.247 7.059c.231.14.265.205.265.504 0 .188-.291 1.392-.647 2.676a975.644 975.644 0 0 0-1.636 6.01c-.544 2.021-1.048 3.814-1.121 3.983-.073.17-.289.452-.48.628-.667.616.326.575-14.255.575H27.268l-.04-.183c-.07-.328-2.577-14.231-2.576-14.294 0-.034 7.486-.061 16.636-.061 16.441 0 16.64.002 16.902.162ZM30.968 55.705c-1.159.281-2.19 1.115-2.726 2.202-.388.79-.522 1.439-.458 2.215.112 1.353.794 2.479 1.965 3.24 1.523.992 3.623.832 5.001-.379a4.263 4.263 0 0 0 .902-5.27c-.521-.925-1.572-1.722-2.634-1.999-.568-.148-1.462-.152-2.05-.009Zm18.873.037c-1.412.406-2.51 1.508-2.931 2.945-.159.54-.168 1.614-.02 2.17a4.212 4.212 0 0 0 4.094 3.145c2.677 0 4.663-2.452 4.115-5.08-.312-1.497-1.578-2.808-3.105-3.214-.583-.155-1.548-.14-2.153.034Zm-16.879 2.1c.753.375 1.182 1.085 1.182 1.954 0 .9-.458 1.591-1.315 1.984-.371.17-.525.195-.995.161a2.149 2.149 0 0 1-1.487-3.576c.626-.731 1.748-.956 2.615-.523Zm18.92-.019c.84.392 1.32 1.21 1.247 2.12-.09 1.135-.863 1.907-2 1.998-1.823.147-2.946-1.863-1.916-3.432.522-.796 1.755-1.112 2.67-.686Z"
}));
var CartCircle_default = SvgCartCircle;

// icons/Chart.tsx
import * as React6 from "react";
var SvgChart = (props) => /* @__PURE__ */ React6.createElement("svg", {
  viewBox: "0 0 20 16",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React6.createElement("path", {
  d: "M19.531 13a.47.47 0 0 1 .469.469v1.562a.47.47 0 0 1-.469.469H.47A.47.47 0 0 1 0 15.031V.97A.47.47 0 0 1 .469.5H2.03A.47.47 0 0 1 2.5.969V13h17.031ZM14.56 4.23 11.25 6.437l-3.332-4.44a.47.47 0 0 0-.777.038L3.75 7.687v4.063h15l-3.512-7.336a.469.469 0 0 0-.68-.184Z"
}));
var Chart_default = SvgChart;

// icons/CheckCircle.tsx
import * as React7 from "react";
var SvgCheckCircle = (props) => /* @__PURE__ */ React7.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  ...props
}, /* @__PURE__ */ React7.createElement("path", {
  d: "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 464c-118.664 0-216-96.055-216-216 0-118.663 96.055-216 216-216 118.664 0 216 96.055 216 216 0 118.663-96.055 216-216 216zm141.63-274.961L217.15 376.071c-4.705 4.667-12.303 4.637-16.97-.068l-85.878-86.572c-4.667-4.705-4.637-12.303.068-16.97l8.52-8.451c4.705-4.667 12.303-4.637 16.97.068l68.976 69.533 163.441-162.13c4.705-4.667 12.303-4.637 16.97.068l8.451 8.52c4.668 4.705 4.637 12.303-.068 16.97z"
}));
var CheckCircle_default = SvgCheckCircle;

// icons/Check.tsx
import * as React8 from "react";
var SvgCheck = (props) => /* @__PURE__ */ React8.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  ...props
}, /* @__PURE__ */ React8.createElement("path", {
  d: "M435.848 83.466 172.804 346.51l-96.652-96.652c-4.686-4.686-12.284-4.686-16.971 0l-28.284 28.284c-4.686 4.686-4.686 12.284 0 16.971l133.421 133.421c4.686 4.686 12.284 4.686 16.971 0l299.813-299.813c4.686-4.686 4.686-12.284 0-16.971l-28.284-28.284c-4.686-4.686-12.284-4.686-16.97 0z"
}));
var Check_default = SvgCheck;

// icons/ChevronDown.tsx
import * as React9 from "react";
var SvgChevronDown = (props) => /* @__PURE__ */ React9.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512",
  ...props
}, /* @__PURE__ */ React9.createElement("path", {
  d: "M224 416c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L224 338.8l169.4-169.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-192 192C240.4 412.9 232.2 416 224 416z"
}));
var ChevronDown_default = SvgChevronDown;

// icons/ChevronLeft.tsx
import * as React10 from "react";
var SvgChevronLeft = (props) => /* @__PURE__ */ React10.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 8 14",
  ...props
}, /* @__PURE__ */ React10.createElement("path", {
  d: "m7.654 13.674.214-.214a.352.352 0 0 0 0-.52l-5.96-5.99L7.868.99a.352.352 0 0 0 0-.519L7.654.257a.352.352 0 0 0-.52 0L.687 6.706a.352.352 0 0 0 0 .52l6.449 6.448a.352.352 0 0 0 .519 0Z"
}));
var ChevronLeft_default = SvgChevronLeft;

// icons/ChevronRight.tsx
import * as React11 from "react";
var SvgChevronRight = (props) => /* @__PURE__ */ React11.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 8 12",
  ...props
}, /* @__PURE__ */ React11.createElement("path", {
  d: "m.9-1.196-.214.214a.352.352 0 0 0 0 .52l5.96 5.96-5.96 5.99a.352.352 0 0 0 0 .519l.214.214a.352.352 0 0 0 .52 0l6.448-6.449a.352.352 0 0 0 0-.52L1.42-1.195a.352.352 0 0 0-.52 0Z"
}));
var ChevronRight_default = SvgChevronRight;

// icons/ChevronUp.tsx
import * as React12 from "react";
var SvgChevronUp = (props) => /* @__PURE__ */ React12.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512",
  ...props
}, /* @__PURE__ */ React12.createElement("path", {
  d: "M416 352c-8.188 0-16.38-3.125-22.62-9.375L224 173.3 54.6 342.7c-12.5 12.5-32.75 12.5-45.25 0s-12.5-32.75 0-45.25l192-192c12.5-12.5 32.75-12.5 45.25 0l192 192c12.5 12.5 12.5 32.75 0 45.25-6.2 6.2-14.4 9.3-22.6 9.3z"
}));
var ChevronUp_default = SvgChevronUp;

// icons/Clock.tsx
import * as React13 from "react";
var SvgClock = (props) => /* @__PURE__ */ React13.createElement("svg", {
  viewBox: "0 0 14 14",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React13.createElement("path", {
  d: "M7 .219a6.78 6.78 0 0 0-6.781 6.78 6.78 6.78 0 0 0 6.78 6.782A6.78 6.78 0 0 0 13.782 7 6.78 6.78 0 0 0 7 .219Zm5.906 6.78A5.917 5.917 0 0 1 7 12.907 5.899 5.899 0 0 1 1.094 7c0-3.227 2.625-5.906 5.906-5.906 3.226 0 5.906 2.652 5.906 5.906ZM8.832 9.435c.137.109.355.054.437-.083l.247-.3c.109-.164.054-.356-.083-.465L7.52 7.19v-4.02a.353.353 0 0 0-.328-.327h-.383a.332.332 0 0 0-.328.328v4.375c0 .11.028.191.11.273l2.242 1.614Z"
}));
var Clock_default = SvgClock;

// icons/Coins.tsx
import * as React14 from "react";
var SvgCoins = (props) => /* @__PURE__ */ React14.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  ...props
}, /* @__PURE__ */ React14.createElement("path", {
  d: "M336 32c-48.6 0-92.6 9-124.5 23.4-.9.4-51.5 21-51.5 56.6v16.7C76.1 132.2 0 163.4 0 208v192c0 44.2 78.8 80 176 80s176-35.8 176-80v-16.4c89.7-3.7 160-37.9 160-79.6V112c0-37-62.1-80-176-80zm-16 368c0 13.9-50.5 48-144 48S32 413.9 32 400v-50.1c31.8 20.6 84.4 34.1 144 34.1s112.2-13.5 144-34.1V400zm0-96c0 13.9-50.5 48-144 48S32 317.9 32 304v-50.1c31.8 20.6 84.4 34.1 144 34.1s112.2-13.5 144-34.1V304zm-144-48c-81 0-146.7-21.5-146.7-48S95 160 176 160s146.7 21.5 146.7 48S257 256 176 256zm304 48c0 13.1-45 43.6-128 47.3v-64.1c52.8-2.2 99.1-14.6 128-33.3V304zm0-96c0 13.1-45.1 43.4-128 47.2V208c0-5.6-1.7-11-4.1-16.3 54.6-1.7 102.4-14.5 132.1-33.8V208zm-144-48c-7.3 0-14-.5-20.9-.9-36.9-21.7-85-28.2-115.6-30-6.3-5.3-10.1-11-10.1-17.1 0-26.5 65.7-48 146.7-48s146.7 21.5 146.7 48S417 160 336 160z"
}));
var Coins_default = SvgCoins;

// icons/Column.tsx
import * as React15 from "react";
var SvgColumn = (props) => /* @__PURE__ */ React15.createElement("svg", {
  clipRule: "evenodd",
  fillRule: "evenodd",
  strokeLinejoin: "round",
  strokeMiterlimit: 2,
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React15.createElement("path", {
  d: "M15.75 3a.75.75 0 0 0-.75.75v16.5a.75.75 0 0 0 1.5 0V3.75a.75.75 0 0 0-.75-.75zm-4 0a.75.75 0 0 0-.75.75v16.5a.75.75 0 0 0 1.5 0V3.75a.75.75 0 0 0-.75-.75zm-4 0a.75.75 0 0 0-.75.75v16.5a.75.75 0 0 0 1.5 0V3.75A.75.75 0 0 0 7.75 3z",
  fillRule: "nonzero"
}));
var Column_default = SvgColumn;

// icons/Copy.tsx
import * as React16 from "react";
var SvgCopy = (props) => /* @__PURE__ */ React16.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512",
  ...props
}, /* @__PURE__ */ React16.createElement("path", {
  d: "m433.941 65.941-51.882-51.882A48 48 0 0 0 348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 0 0-14.059-33.941zM352 32.491a15.88 15.88 0 0 1 7.431 4.195l51.882 51.883A15.885 15.885 0 0 1 415.508 96H352V32.491zM288 464c0 8.822-7.178 16-16 16H48c-8.822 0-16-7.178-16-16V144c0-8.822 7.178-16 16-16h80v240c0 26.51 21.49 48 48 48h112v48zm128-96c0 8.822-7.178 16-16 16H176c-8.822 0-16-7.178-16-16V48c0-8.822 7.178-16 16-16h144v72c0 13.2 10.8 24 24 24h72v240z"
}));
var Copy_default = SvgCopy;

// icons/CreditCard.tsx
import * as React17 from "react";
var SvgCreditCard = (props) => /* @__PURE__ */ React17.createElement("svg", {
  viewBox: "0 0 14 11",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React17.createElement("path", {
  d: "M12.375.25H1.125C.492.25 0 .766 0 1.375v8.25a1.11 1.11 0 0 0 1.125 1.125h11.25c.61 0 1.125-.492 1.125-1.125v-8.25A1.14 1.14 0 0 0 12.375.25ZM1.125 1h11.25c.188 0 .375.188.375.375V2.5h-12V1.375C.75 1.187.914 1 1.125 1Zm11.25 9H1.125a.37.37 0 0 1-.375-.375V4.75h12v4.875c0 .21-.188.375-.375.375ZM4.5 8.031c0-.14-.14-.281-.281-.281H2.53a.285.285 0 0 0-.281.281v.188a.27.27 0 0 0 .281.281H4.22c.14 0 .281-.117.281-.281V8.03Zm4.5 0c0-.14-.14-.281-.281-.281H5.53a.285.285 0 0 0-.281.281v.188a.27.27 0 0 0 .281.281H8.72c.14 0 .281-.117.281-.281V8.03Z"
}));
var CreditCard_default = SvgCreditCard;

// icons/Crosshair.tsx
import * as React18 from "react";
var SvgCrosshair = (props) => /* @__PURE__ */ React18.createElement("svg", {
  viewBox: "0 0 17 16",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React18.createElement("path", {
  d: "M16.313 7.5h-1.094A6.765 6.765 0 0 0 9 1.281V.188A.202.202 0 0 0 8.812 0h-.624C8.062 0 8 .094 8 .188V1.28c-3.344.25-6 2.907-6.25 6.219H.687C.563 7.5.5 7.594.5 7.688v.625c0 .124.063.187.188.187H1.75c.25 3.344 2.906 6 6.25 6.25v1.063c0 .124.063.187.188.187h.624c.094 0 .188-.063.188-.188V14.75c3.313-.25 5.969-2.906 6.219-6.25h1.094c.093 0 .187-.063.187-.188v-.624a.202.202 0 0 0-.188-.188ZM9 13.75v-2.063a.202.202 0 0 0-.188-.187h-.624c-.126 0-.188.094-.188.188v2.062A5.777 5.777 0 0 1 2.75 8.5h2.063c.093 0 .187-.063.187-.188v-.624a.202.202 0 0 0-.188-.188H2.75A5.774 5.774 0 0 1 8 2.281v2.031c0 .125.063.188.188.188h.624c.094 0 .188-.063.188-.188v-2.03A5.77 5.77 0 0 1 14.219 7.5h-2.031c-.126 0-.188.094-.188.188v.625c0 .124.063.187.188.187h2.03c-.25 2.781-2.437 5-5.218 5.25ZM9.25 8a.76.76 0 0 0-.75-.75.74.74 0 0 0-.75.75c0 .438.313.75.75.75A.74.74 0 0 0 9.25 8Z",
  fill: "#404040"
}));
var Crosshair_default = SvgCrosshair;

// icons/Delete.tsx
import * as React19 from "react";
var SvgDelete = (props) => /* @__PURE__ */ React19.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512",
  ...props
}, /* @__PURE__ */ React19.createElement("path", {
  d: "M135.2 17.69C140.6 6.848 151.7 0 163.8 0h120.4c12.1 0 23.2 6.848 28.6 17.69L320 32h96c17.7 0 32 14.33 32 32s-14.3 32-32 32H32C14.33 96 0 81.67 0 64s14.33-32 32-32h96l7.2-14.31zM31.1 128H416v320c0 35.3-28.7 64-64 64H95.1c-34.45 0-64-28.7-64-64V128zm80 80v224c0 8.8 8.1 16 16 16 9.7 0 16-7.2 16-16V208c0-8.8-6.3-16-16-16-7.9 0-16 7.2-16 16zm96 0v224c0 8.8 8.1 16 16 16 9.7 0 16.9-7.2 16.9-16V208c0-8.8-7.2-16-16.9-16-7.9 0-16 7.2-16 16zm96.9 0v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16s-16 7.2-16 16z"
}));
var Delete_default = SvgDelete;

// icons/DollarSign.tsx
import * as React20 from "react";
var SvgDollarSign = (props) => /* @__PURE__ */ React20.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 320 512",
  ...props
}, /* @__PURE__ */ React20.createElement("path", {
  d: "M160 0c17.7 0 32 14.33 32 32v35.68c1.6.21 3.1.44 4.7.67 10.6 1.58 42.2 6.67 55.2 9.96 16.2 4.34 27.5 21.79 23.1 38.89-4.3 17.1-21.7 27.5-38.9 23.2-9.3-3.3-37.6-7.1-48.8-8.7-32.1-4.8-59.6-2.4-78.5 4.8-18.28 7-25.87 16.9-27.88 28-1.94 10.7-.47 16.8 1.29 20.6 1.89 4 5.58 8.5 12.93 13.4 16.26 10.7 41.06 17.9 73.26 26.6l2.8.8c28.4 7.7 63.2 17.2 89 34.3 14.1 9.4 27.4 22.1 35.6 39.7 8.3 17.8 10.1 37.8 6.3 58.2-7 38.9-34 64.3-65.7 77.5-13.6 5.6-28.6 9.2-44.4 11V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-34.9c-.4 0-.9-1-1.3-.2h-.2c-24.3-3.8-64.43-14.3-91.5-26.3-16.15-7.2-23.42-26.1-16.24-42.3 7.18-16.1 26.09-23.4 41.34-16.2 21.8 9.3 56.2 18.4 76.1 21.5 32 4.8 58.3 2 76.1-5.2 16.9-6.9 24.6-16.9 26.8-28.9 1.9-10.7.5-16.8-1.3-20.6-1.9-4-5.6-8.5-12.9-13.4-16.3-10.7-41.1-17.9-73.3-26.6l-2.8-.8c-28.4-7.7-63.22-17.2-89.04-34.3-14.11-9.4-27.33-22.1-35.54-39.7-8.33-17.8-10.14-37.8-6.27-59.1 7.08-38.9 35.1-63.71 68.01-76.27 13.02-4.97 27.14-8.24 42.04-10V32c0-17.67 14.3-32 32-32z"
}));
var DollarSign_default = SvgDollarSign;

// icons/Download.tsx
import * as React21 from "react";
var SvgDownload = (props) => /* @__PURE__ */ React21.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  ...props
}, /* @__PURE__ */ React21.createElement("path", {
  d: "M480 352H346.5l-45.25 45.25C289.2 409.3 273.1 416 256 416s-33.16-6.656-45.25-18.75L165.5 352H32c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-96c0-17.7-14.3-32-32-32zm-48 104c-13.2 0-24-10.8-24-24s10.8-24 24-24 24 10.8 24 24-10.8 24-24 24zm-198.6-81.4c6.2 6.3 14.4 9.4 22.6 9.4s16.38-3.125 22.62-9.375l128-128c12.49-12.5 12.49-32.75 0-45.25-12.5-12.5-32.76-12.5-45.25 0L288 274.8V32c0-17.67-14.33-32-32-32-17.7 0-32 14.33-32 32v242.8l-73.4-73.4c-12.49-12.5-32.75-12.5-45.25 0-12.49 12.5-12.49 32.75 0 45.25L233.4 374.6z"
}));
var Download_default = SvgDownload;

// icons/DragIcon.tsx
import * as React22 from "react";
var SvgDragIcon = (props) => /* @__PURE__ */ React22.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 320 512",
  ...props
}, /* @__PURE__ */ React22.createElement("path", {
  d: "M88 352c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H40c-22.09 0-40-17.9-40-40v-48c0-22.1 17.91-40 40-40h48zm192 0c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40h-48c-22.1 0-40-17.9-40-40v-48c0-22.1 17.9-40 40-40h48zM40 320c-22.09 0-40-17.9-40-40v-48c0-22.1 17.91-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H40zm240-128c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40h-48c-22.1 0-40-17.9-40-40v-48c0-22.1 17.9-40 40-40h48zM40 160c-22.09 0-40-17.9-40-40V72c0-22.09 17.91-40 40-40h48c22.1 0 40 17.91 40 40v48c0 22.1-17.9 40-40 40H40zM280 32c22.1 0 40 17.91 40 40v48c0 22.1-17.9 40-40 40h-48c-22.1 0-40-17.9-40-40V72c0-22.09 17.9-40 40-40h48z"
}));
var DragIcon_default = SvgDragIcon;

// icons/Edit.tsx
import * as React23 from "react";
var SvgEdit = (props) => /* @__PURE__ */ React23.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  ...props
}, /* @__PURE__ */ React23.createElement("path", {
  d: "M362.7 19.32c25-24.998 65.6-24.998 90.6 0l39.4 39.43c25 24.99 25 65.55 0 90.55l-48.4 48.4-130-129.98 48.4-48.4zm59 200.98L188.5 453.4c-10.4 10.4-23.3 18.1-37.4 22.2L30.77 511c-8.42 2.5-17.53.2-23.74-6.9-6.21-5.3-8.532-14.4-6.054-22.9L36.37 360.9c4.16-14.1 11.79-27 22.2-37.4L291.7 90.34l130 129.96z"
}));
var Edit_default = SvgEdit;

// icons/EllipsisVertical.tsx
import * as React24 from "react";
var SvgEllipsisVertical = (props) => /* @__PURE__ */ React24.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 128 512",
  ...props
}, /* @__PURE__ */ React24.createElement("path", {
  d: "M64 360c30.93 0 56 25.1 56 56s-25.07 56-56 56-56-25.1-56-56 25.07-56 56-56zm0-160c30.93 0 56 25.1 56 56s-25.07 56-56 56-56-25.1-56-56 25.07-56 56-56zm0-48c-30.93 0-56-25.1-56-56 0-30.93 25.07-56 56-56s56 25.07 56 56c0 30.9-25.07 56-56 56z"
}));
var EllipsisVertical_default = SvgEllipsisVertical;

// icons/EyeSlash.tsx
import * as React25 from "react";
var SvgEyeSlash = (props) => /* @__PURE__ */ React25.createElement("svg", {
  viewBox: "0 0 14 12",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React25.createElement("path", {
  d: "M7 9.15a3.138 3.138 0 0 1-3.126-2.912L1.58 4.465A7.29 7.29 0 0 0 .776 5.68a.708.708 0 0 0 0 .638C1.962 8.634 4.311 10.2 7 10.2c.589 0 1.157-.087 1.704-.229l-1.135-.878A3.152 3.152 0 0 1 7 9.15Zm6.865 1.27-2.418-1.868a7.247 7.247 0 0 0 1.777-2.233.708.708 0 0 0 0-.638C12.038 3.366 9.689 1.8 7 1.8a6.74 6.74 0 0 0-3.223.825L.994.474a.35.35 0 0 0-.49.061l-.43.553a.35.35 0 0 0 .061.491l12.87 9.947a.35.35 0 0 0 .492-.061l.43-.553a.35.35 0 0 0-.062-.491Zm-4.02-3.105-.859-.665a2.073 2.073 0 0 0-2.54-2.667c.132.179.204.395.204.617a1.02 1.02 0 0 1-.034.219l-1.61-1.245A3.113 3.113 0 0 1 7 2.85 3.148 3.148 0 0 1 10.15 6c0 .473-.116.914-.304 1.315Z"
}));
var EyeSlash_default = SvgEyeSlash;

// icons/Eye.tsx
import * as React26 from "react";
var SvgEye = (props) => /* @__PURE__ */ React26.createElement("svg", {
  viewBox: "0 0 14 10",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React26.createElement("path", {
  d: "M13.915 4.645C12.597 2.073 9.988.333 7 .333S1.402 2.075.085 4.645a.786.786 0 0 0 0 .71C1.403 7.927 4.012 9.667 7 9.667s5.598-1.742 6.915-4.312a.786.786 0 0 0 0-.71ZM7 8.5a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7Zm0-5.833a2.317 2.317 0 0 0-.615.092 1.163 1.163 0 0 1-1.626 1.626A2.328 2.328 0 1 0 7 2.667Z"
}));
var Eye_default = SvgEye;

// icons/FileInvoiceDollar.tsx
import * as React27 from "react";
var SvgFileInvoiceDollar = (props) => /* @__PURE__ */ React27.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 384 512",
  ...props
}, /* @__PURE__ */ React27.createElement("path", {
  d: "M384 128H256V0l128 128zm-128 32h128v304c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.5-48-48V48C0 21.49 21.49 0 48 0h176l.004 128C224 145.7 238.3 160 256 160zM64 88c0 4.38 3.63 8 8 8h80c4.4 0 8-3.62 8-8V72c0-4.37-3.6-8-8-8H72c-4.37 0-8 3.63-8 8v16zm8 72h80c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H72c-4.37 0-8 3.6-8 8v16c0 4.4 3.63 8 8 8zm125.5 156.8-6.4-1.6c-22.8-7-22.3-11.1-21.5-14.7 1.375-7.812 16.59-9.719 30.27-7.625 5.594.844 11.73 2.812 17.59 4.844 10.39 3.594 21.83-1.938 25.45-12.34 3.625-10.44-1.891-21.84-12.33-25.47-7.219-2.484-13.11-4.078-18.56-5.273V248c0-11.03-8.953-20-20-20s-20 8.969-20 20v5.992C149.6 258.8 133.8 272.8 130.2 293.7c-7.406 42.84 33.19 54.75 50.52 59.84l5.812 1.688c29.28 8.375 28.8 11.19 27.92 16.28-1.375 7.812-16.59 9.75-30.31 7.625-6.938-1.031-15.81-4.219-23.66-7.031l-4.469-1.625c-10.41-3.594-21.83 1.812-25.52 12.22-3.672 10.41 1.781 21.84 12.2 25.53l4.266 1.5c7.758 2.789 16.38 5.59 25.06 7.512V424c0 11.03 8.953 20 20 20s20-8.969 20-20v-6.254c22.36-4.793 38.21-18.53 41.83-39.43C261.3 335 219.8 323.1 197.5 316.8z"
}));
var FileInvoiceDollar_default = SvgFileInvoiceDollar;

// icons/File.tsx
import * as React28 from "react";
var SvgFile = (props) => /* @__PURE__ */ React28.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 384 512",
  ...props
}, /* @__PURE__ */ React28.createElement("path", {
  d: "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 236c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-64c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-72v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm96-114.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
}));
var File_default = SvgFile;

// icons/FrenchFries.tsx
import * as React29 from "react";
var SvgFrenchFries = (props) => /* @__PURE__ */ React29.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 384 512",
  ...props
}, /* @__PURE__ */ React29.createElement("path", {
  d: "m368 223.1-34-.003c-6.875 0-13.75 4.25-15.25 11-8.5 39-62 69-126.8 69-64.62 0-118.1-30-126.8-69C63.75 228.2 56.1 223.1 49.1 223.1l-34 .003c-4.875 0-9.522 2.28-12.52 6.03C.477 233.8-.627 238.7.373 243.5L54.503 487c3.25 14.63 16.25 25 31.25 25h212.5c14.1 0 28-10.37 31.25-25l54.13-243.5c.1-4.75-.103-9.716-3.103-13.47-3.03-3.73-7.63-6.93-12.53-6.93zm-80.5 5c.5-1.75 1.5-3.25 2.125-4.875l30.12-172.5c1-5.5-1-11-5.125-14.63-4.125-3.75-9.875-5-15.25-3.375l-34.25 10.25c-4.25 1.25-7.125 4.5-9.125 8.25v207.3C273.5 250.1 285.1 238.1 287.5 228.1zm80-37 16.25-93.26c1-5.5-.1-11-5.125-14.63-4.125-3.75-9.875-5-15.25-3.375l-17.25 5.125-18.75 107.3c2.25-.375 4.25-1.125 6.625-1.125h33.5zm-144.4 77.6V31.97c0-6-3.375-11.63-8.875-14.25L183.1 1.722c-4.8-2.5-10.8-2.25-15.5.625-4.7 2.875-7.6 8.123-7.6 13.623v252.8c21.1 4.33 42.9 4.33 63.1-.07zM50 191.1c3.625 0 6.1 1 10.37 1.75L40.38 86.6l-19.75-5.87c-5.38-1.63-11.126-.38-15.251 3.25C1.254 87.73-.746 93.23.254 98.73l16.25 93.26H50zm78 67.4V33.1l-3.7-20c-.1-5.5-4.75-10-9.1-12-6.1-2.003-11.9-1.253-16.32 2.122L70.38 24.85c-4.88 3.62-7.25 9.75-6.13 15.75l36.87 197.1c5.38 7.7 14.48 14.9 26.88 20.8z"
}));
var FrenchFries_default = SvgFrenchFries;

// icons/Gear.tsx
import * as React30 from "react";
var SvgGear = (props) => /* @__PURE__ */ React30.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  ...props
}, /* @__PURE__ */ React30.createElement("path", {
  d: "M495.9 166.6c3.3 8.6.5 18.3-6.3 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4 0 8.6-.6 17.1-1.7 25.4l43.3 39.4c6.8 6.3 9.6 16 6.3 24.6-4.4 11.9-9.7 23.4-15.7 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.3-6 7.1-15.7 9.6-24.5 6.8l-55.7-17.8c-13.4 10.3-29.1 18.9-44 25.5l-12.5 57.1c-2 9-9 15.4-18.2 17.8-13.8 2.3-28 3.5-43.4 3.5-13.6 0-27.8-1.2-41.6-3.5-9.2-2.4-16.2-8.8-18.2-17.8l-12.5-57.1c-15.8-6.6-30.6-15.2-44-25.5l-55.66 17.8c-8.84 2.8-18.59.3-24.51-6.8-8.11-9.9-15.51-20.3-22.11-31.3l-4.68-8.1c-6.07-10.9-11.35-22.4-15.78-34.3-3.24-8.6-.51-18.3 6.35-24.6l43.26-39.4C64.57 273.1 64 264.6 64 256c0-8.6.57-17.1 1.67-25.4l-43.26-39.4c-6.86-6.3-9.59-15.9-6.35-24.6 4.43-11.9 9.72-23.4 15.78-34.3l4.67-8.1c6.61-11 14.01-21.4 22.12-31.25 5.92-7.15 15.67-9.63 24.51-6.81l55.66 17.76c13.4-10.34 28.2-18.94 44-25.47l12.5-57.1c2-9.08 9-16.29 18.2-17.82C227.3 1.201 241.5 0 256 0s28.7 1.201 42.5 3.51c9.2 1.53 16.2 8.74 18.2 17.82l12.5 57.1c14.9 6.53 30.6 15.13 44 25.47l55.7-17.76c8.8-2.82 18.5-.34 24.5 6.81 8.1 9.85 15.5 20.25 22.1 31.25l4.7 8.1c6 10.9 11.3 22.4 15.7 34.3zM256 336c44.2 0 80-35.8 80-80.9 0-43.3-35.8-80-80-80s-80 36.7-80 80c0 45.1 35.8 80.9 80 80.9z"
}));
var Gear_default = SvgGear;

// icons/Gift.tsx
import * as React31 from "react";
var SvgGift = (props) => /* @__PURE__ */ React31.createElement("svg", {
  viewBox: "0 0 14 14",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React31.createElement("path", {
  d: "M12.688 3.5h-1.094c.273-.355.437-.793.437-1.313C12.031.984 11.101 0 9.981 0 8.831 0 8.147.71 7 2.625 5.824.711 5.14 0 3.992 0 2.872 0 1.97.984 1.97 2.188c0 .519.136.957.41 1.312H1.312C.575 3.5 0 4.102 0 4.813v2.625c0 .246.191.437.438.437h.437v3.938c0 .738.574 1.312 1.313 1.312h9.624c.711 0 1.313-.574 1.313-1.313V7.876h.438A.45.45 0 0 0 14 7.437V4.813A1.33 1.33 0 0 0 12.687 3.5Zm-5.141-.082C8.887 1.148 9.352.875 9.98.875c.63 0 1.176.602 1.176 1.313 0 .738-.547 1.312-1.176 1.312H7.492l.055-.082ZM3.992.875c.63 0 1.094.273 2.434 2.543l.054.082H3.992c-.629 0-1.176-.574-1.176-1.313.028-.71.547-1.312 1.176-1.312ZM5.25 12.25H2.187a.432.432 0 0 1-.437-.438V7.876h3.5v4.375Zm0-5.25H.875V4.812a.45.45 0 0 1 .438-.437H5.25V7Zm2.625 5.25h-1.75V4.375h1.75v7.875Zm4.375-.438a.45.45 0 0 1-.438.438H8.75V7.875h3.5v3.938ZM13.125 7H8.75V4.375h3.938a.47.47 0 0 1 .437.438V7Z"
}));
var Gift_default = SvgGift;

// icons/Globe.tsx
import * as React32 from "react";
var SvgGlobe = (props) => /* @__PURE__ */ React32.createElement("svg", {
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React32.createElement("path", {
  d: "M8 .25A7.749 7.749 0 0 0 .25 8 7.749 7.749 0 0 0 8 15.75 7.749 7.749 0 0 0 15.75 8 7.749 7.749 0 0 0 8 .25ZM14.03 5h-2.594c-.28-1.375-.75-2.563-1.343-3.406A6.95 6.95 0 0 1 14.03 5ZM10.75 8a13 13 0 0 1-.156 2h-5.22c-.093-.594-.124-1.281-.124-2 0-.688.031-1.375.125-2h5.219c.093.625.156 1.312.156 2ZM8 1.25c.812 0 1.906 1.406 2.437 3.75H5.531C6.062 2.656 7.156 1.25 8 1.25Zm-2.125.344C5.28 2.437 4.812 3.624 4.53 5H1.937a6.95 6.95 0 0 1 3.938-3.406ZM1.25 8c0-.688.094-1.344.281-2h2.844a14.03 14.03 0 0 0-.125 2c0 .719.031 1.375.125 2H1.53a6.875 6.875 0 0 1-.281-2Zm.687 3h2.594c.281 1.406.75 2.594 1.344 3.437A6.89 6.89 0 0 1 1.937 11ZM8 14.75c-.844 0-1.938-1.375-2.469-3.75h4.906c-.53 2.375-1.625 3.75-2.437 3.75Zm2.094-.313c.593-.843 1.062-2.03 1.343-3.437h2.594a6.89 6.89 0 0 1-3.937 3.437Zm1.5-4.437c.093-.625.156-1.281.156-2 0-.688-.063-1.344-.156-2h2.843c.188.656.313 1.312.313 2 0 .719-.125 1.375-.313 2h-2.843Z"
}));
var Globe_default = SvgGlobe;

// icons/HamburgerMenu.tsx
import * as React33 from "react";
var SvgHamburgerMenu = (props) => /* @__PURE__ */ React33.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512",
  ...props
}, /* @__PURE__ */ React33.createElement("path", {
  d: "M0 96c0-17.67 14.33-32 32-32h384c17.7 0 32 14.33 32 32 0 17.7-14.3 32-32 32H32c-17.67 0-32-14.3-32-32zm0 160c0-17.7 14.33-32 32-32h384c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.67 0-32-14.3-32-32zm416 192H32c-17.67 0-32-14.3-32-32s14.33-32 32-32h384c17.7 0 32 14.3 32 32s-14.3 32-32 32z"
}));
var HamburgerMenu_default = SvgHamburgerMenu;

// icons/Home.tsx
import * as React34 from "react";
var SvgHome = (props) => /* @__PURE__ */ React34.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 576 512",
  ...props
}, /* @__PURE__ */ React34.createElement("path", {
  d: "m511.8 287.6.7 160.1c0 2.8-.2 5.4-.5 8.1V472c0 22.1-17.9 40-40 40h-16c-1.1 0-2.2-.9-3.3-.1-1.4-.8-2.8.1-4.2.1H392c-22.1 0-40-17.9-40-40v-88c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32v88c0 22.1-17.9 40-40 40h-55.9c-1.5 0-3-.1-4.5-.2-1.2.1-2.4.2-3.6.2h-16c-22.09 0-40-17.9-40-40V360c0-.9.03-1.9.09-2.8v-69.6H32.05C14.02 287.6 0 273.5 0 255.5c0-9 3.004-17 10.01-24L266.4 8.016c7-7.014 15-8.016 22-8.016s15 2.004 21.1 7.014L416 100.7V64c0-17.67 14.3-32 32-32h32c17.7 0 32 14.33 32 32v121l52.8 46.5c8 7 12.1 15 11 24 0 18-15 32.1-32 32.1h-32z"
}));
var Home_default = SvgHome;

// icons/InfoCircle.tsx
import * as React35 from "react";
var SvgInfoCircle = (props) => /* @__PURE__ */ React35.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  ...props
}, /* @__PURE__ */ React35.createElement("path", {
  d: "M256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm-36 344h12V232h-12c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h48c6.627 0 12 5.373 12 12v140h12c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12h-72c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12zm36-240c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z"
}));
var InfoCircle_default = SvgInfoCircle;

// icons/Link.tsx
import * as React36 from "react";
var SvgLink = (props) => /* @__PURE__ */ React36.createElement("svg", {
  viewBox: "0 0 14 14",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React36.createElement("path", {
  d: "M8.234 10.793 6.07 12.958a3.552 3.552 0 0 1-5.027 0 3.552 3.552 0 0 1 0-5.027l2.165-2.165.097-.094a.328.328 0 0 1 .552.227c.006.131.017.263.034.393a.33.33 0 0 1-.093.276l-2.06 2.059a2.57 2.57 0 0 0 0 3.635 2.57 2.57 0 0 0 3.636 0l2.165-2.165.01-.01a2.574 2.574 0 0 0-.764-4.148.33.33 0 0 1-.195-.32 1.7 1.7 0 0 1 .077-.416.326.326 0 0 1 .435-.2 3.559 3.559 0 0 1 1.133 5.79ZM5.765 8.235c.335.334.721.589 1.133.762a.326.326 0 0 0 .436-.2 1.7 1.7 0 0 0 .077-.417.33.33 0 0 0-.195-.319 2.574 2.574 0 0 1-.764-4.148l.01-.01 2.165-2.165a2.57 2.57 0 0 1 3.635 0 2.57 2.57 0 0 1 0 3.635l-2.059 2.059a.33.33 0 0 0-.093.276c.017.13.028.261.033.393a.328.328 0 0 0 .553.227 3.52 3.52 0 0 0 .097-.093l2.165-2.166a3.552 3.552 0 0 0 0-5.027 3.552 3.552 0 0 0-5.027 0L5.765 3.207a3.559 3.559 0 0 0 0 5.028Z"
}));
var Link_default = SvgLink;

// icons/List.tsx
import * as React37 from "react";
var SvgList = (props) => /* @__PURE__ */ React37.createElement("svg", {
  viewBox: "0 0 14 14",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React37.createElement("path", {
  d: "M12.687 1.75a.47.47 0 0 1 .438.437v9.625a.45.45 0 0 1-.438.438H1.312a.432.432 0 0 1-.437-.438V2.187a.45.45 0 0 1 .437-.437h11.375Zm0-.875H1.312C.574.875 0 1.476 0 2.187v9.625c0 .739.574 1.313 1.312 1.313h11.375c.711 0 1.313-.574 1.313-1.313V2.187A1.33 1.33 0 0 0 12.687.875ZM3.5 3.5a.881.881 0 0 0-.875.875c0 .492.383.875.875.875a.881.881 0 0 0 .875-.875A.9.9 0 0 0 3.5 3.5Zm0 2.625A.881.881 0 0 0 2.625 7c0 .492.383.875.875.875A.881.881 0 0 0 4.375 7a.9.9 0 0 0-.875-.875Zm0 2.625a.881.881 0 0 0-.875.875c0 .492.383.875.875.875a.881.881 0 0 0 .875-.875.9.9 0 0 0-.875-.875Zm7.875-4.047v-.656a.176.176 0 0 0-.164-.164H5.414c-.11 0-.164.082-.164.164v.656c0 .11.055.164.164.164h5.797c.082 0 .164-.055.164-.164Zm0 2.625v-.656a.176.176 0 0 0-.164-.164H5.414c-.11 0-.164.082-.164.164v.656c0 .11.055.164.164.164h5.797c.082 0 .164-.055.164-.164Zm0 2.625v-.656a.176.176 0 0 0-.164-.164H5.414c-.11 0-.164.082-.164.164v.656c0 .11.055.164.164.164h5.797c.082 0 .164-.055.164-.164Z"
}));
var List_default = SvgList;

// icons/LocationArrow.tsx
import * as React38 from "react";
var SvgLocationArrow = (props) => /* @__PURE__ */ React38.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512",
  ...props
}, /* @__PURE__ */ React38.createElement("path", {
  d: "M285.6 444.1a32 32 0 0 1-35.8 19.3c-15-3-26.7-16.1-26.7-31.4V256h-176a32 32 0 0 1-11.2-61.6l352-144A32 32 0 0 1 429.6 92l-144 352z"
}));
var LocationArrow_default = SvgLocationArrow;

// icons/Lock.tsx
import * as React39 from "react";
var SvgLock = (props) => /* @__PURE__ */ React39.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512",
  ...props
}, /* @__PURE__ */ React39.createElement("path", {
  d: "M400 224h-16v-62.5C384 73.1 312.9.3 224.5 0 136-.3 64 71.6 64 160v64H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48zM96 160c0-70.6 57.4-128 128-128s128 57.4 128 128v64H96v-64zm304 320H48c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v192c0 8.8-7.2 16-16 16z"
}));
var Lock_default = SvgLock;

// icons/Mail.tsx
import * as React40 from "react";
var SvgMail = (props) => /* @__PURE__ */ React40.createElement("svg", {
  viewBox: "0 0 14 12",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React40.createElement("path", {
  d: "M12.687.75H1.312C.574.75 0 1.35 0 2.062v7.875c0 .739.574 1.313 1.312 1.313h11.375c.711 0 1.313-.574 1.313-1.313V2.062A1.33 1.33 0 0 0 12.687.75Zm-11.375.875h11.375a.47.47 0 0 1 .438.437v1.149c-.602.492-1.477 1.203-4.129 3.308C8.531 6.902 7.629 7.777 7 7.75c-.656.028-1.559-.847-2.024-1.23C2.324 4.414 1.45 3.703.875 3.211V2.062a.45.45 0 0 1 .437-.437Zm11.375 8.75H1.312a.432.432 0 0 1-.437-.438V4.332c.601.52 1.586 1.312 3.555 2.871.574.465 1.558 1.45 2.57 1.422.984.027 1.969-.957 2.543-1.422a238.156 238.156 0 0 0 3.582-2.871v5.605a.45.45 0 0 1-.438.438Z"
}));
var Mail_default = SvgMail;

// icons/MapMarkerSolid.tsx
import * as React41 from "react";
var SvgMapMarkerSolid = (props) => /* @__PURE__ */ React41.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 384 512",
  ...props
}, /* @__PURE__ */ React41.createElement("path", {
  d: "M168.3 499.2C116.1 435 0 279.4 0 192 0 85.96 85.96 0 192 0c106 0 192 85.96 192 192 0 87.4-117 243-168.3 307.2-12.3 15.3-35.1 15.3-47.4 0zM192 256c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64z"
}));
var MapMarkerSolid_default = SvgMapMarkerSolid;

// icons/MapMarker.tsx
import * as React42 from "react";
var SvgMapMarker = (props) => /* @__PURE__ */ React42.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 384 512",
  ...props
}, /* @__PURE__ */ React42.createElement("path", {
  d: "M272 192a80 80 0 1 1-160 0 80 80 0 0 1 160 0zm-80-32a32 32 0 1 0 0 64 32 32 0 0 0 0-64zm192 32c0 87.4-117 243-168.3 307.2a30.2 30.2 0 0 1-47.4 0C116.1 435 0 279.4 0 192a192 192 0 1 1 384 0zM192 48A144 144 0 0 0 48 192c0 12.4 4.5 31.6 15.3 57.2a603.8 603.8 0 0 0 42.5 79.9c28.4 46.2 61.4 90 86.2 122.6 24.8-32.6 57.8-76.4 86.2-122.6a611 611 0 0 0 42.5-79.9c10.8-25.6 15.3-44.8 15.3-57.2A144 144 0 0 0 192 48z"
}));
var MapMarker_default = SvgMapMarker;

// icons/Megaphone.tsx
import * as React43 from "react";
var SvgMegaphone = (props) => /* @__PURE__ */ React43.createElement("svg", {
  viewBox: "0 0 14 13",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React43.createElement("path", {
  d: "M13.125 5.083V1.422c0-.192-.168-.766-.766-.766a.668.668 0 0 0-.478.192L9.823 2.475c-1.005.813-2.297 1.244-3.589 1.244H1.641c-.862 0-1.532.694-1.532 1.531v2.297c0 .861.67 1.531 1.532 1.531l-.024.766c0 .957.215 1.866.622 2.655.12.264.383.407.67.407h2.536c.622 0 1.005-.694.622-1.196a3.123 3.123 0 0 1-.622-1.866c0-.263.048-.503.096-.766h.693a5.76 5.76 0 0 1 3.59 1.268l2.057 1.627c.12.12.287.168.454.168.599 0 .766-.527.766-.766V7.738c.479-.263.766-.765.766-1.34.024-.55-.287-1.052-.742-1.315Zm-7.68 7.058H2.909a5.361 5.361 0 0 1-.527-2.273v-.766l.024-.024h2.369c-.048.263-.096.527-.096.766 0 .861.263 1.65.766 2.297ZM1.64 8.312a.756.756 0 0 1-.766-.765V5.25a.77.77 0 0 1 .766-.766h4.593v3.829H1.641Zm10.718 3.04c0 .023-.024.023-.024.023l-2.033-1.627A6.509 6.509 0 0 0 7 8.384V4.437a6.724 6.724 0 0 0 3.302-1.364l2.034-1.627h.023v9.905Z"
}));
var Megaphone_default = SvgMegaphone;

// icons/Minus.tsx
import * as React44 from "react";
var SvgMinus = (props) => /* @__PURE__ */ React44.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512",
  ...props
}, /* @__PURE__ */ React44.createElement("path", {
  d: "M400 288H48c-17.69 0-32-14.32-32-32.01S30.31 224 48 224h352c17.69 0 32 14.3 32 31.99S417.7 288 400 288z"
}));
var Minus_default = SvgMinus;

// icons/Phone.tsx
import * as React45 from "react";
var SvgPhone = (props) => /* @__PURE__ */ React45.createElement("svg", {
  viewBox: "0 0 14 14",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React45.createElement("path", {
  d: "m13.483 9.606-2.964-1.272a.858.858 0 0 0-.998.244l-1.206 1.474a9.57 9.57 0 0 1-4.364-4.364l1.474-1.206a.857.857 0 0 0 .243-.998L4.397.517a.857.857 0 0 0-.98-.495L.663.66A.849.849 0 0 0 0 1.491C0 8.416 5.614 14 12.51 14a.854.854 0 0 0 .834-.664l.634-2.754a.853.853 0 0 0-.495-.976Zm-.99 3.519C6.08 13.117.883 7.922.878 1.51L3.6.88l1.258 2.937-1.99 1.627c1.323 2.822 2.857 4.362 5.69 5.69l1.626-1.99 2.937 1.258-.63 2.723Z"
}));
var Phone_default = SvgPhone;

// icons/Pizza.tsx
import * as React46 from "react";
var SvgPizza = (props) => /* @__PURE__ */ React46.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  ...props
}, /* @__PURE__ */ React46.createElement("path", {
  d: "M100.4 112.3.51 491.7c-1.375 5.625.162 11.6 4.287 15.6 4.127 4.125 10.13 5.744 15.63 4.119l379.1-105.1C395.3 231.4 276.5 114.1 100.4 112.3zM127.1 416c-17.62 0-32-14.38-32-31.1 0-17.62 14.39-32 32.01-32 17.63 0 32 14.38 32 31.1.89 17.6-13.51 32-32.01 32zm48-144.9c-17.63 0-32-14.38-32-32 0-17.62 14.38-31.1 32-31.1 17.62 0 32 14.38 32 31.1.9 18.5-13.5 32-32 32zm96.9 96c-17.62 0-32-14.38-32-31.1 0-17.62 14.38-32 32-32 17.63 0 32 14.38 32 32 0 17.6-14.4 31.1-32 31.1zM158.9.14c-16.13-1.5-31.25 8.502-35.38 24.12L108.7 80.52c187.6 5.5 314.5 130.6 322.5 316.1l56.88-15.75c15.75-4.375 25.5-19.62 23.63-35.87C490.9 165.1 340.8 17.39 158.9.14z"
}));
var Pizza_default = SvgPizza;

// icons/PlusCircle.tsx
import * as React47 from "react";
var SvgPlusCircle = (props) => /* @__PURE__ */ React47.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  ...props
}, /* @__PURE__ */ React47.createElement("path", {
  d: "M384 250v12c0 6.6-5.4 12-12 12h-98v98c0 6.6-5.4 12-12 12h-12c-6.6 0-12-5.4-12-12v-98h-98c-6.6 0-12-5.4-12-12v-12c0-6.6 5.4-12 12-12h98v-98c0-6.6 5.4-12 12-12h12c6.6 0 12 5.4 12 12v98h98c6.6 0 12 5.4 12 12zm120 6c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-32 0c0-119.9-97.3-216-216-216-119.9 0-216 97.3-216 216 0 119.9 97.3 216 216 216 119.9 0 216-97.3 216-216z"
}));
var PlusCircle_default = SvgPlusCircle;

// icons/Plus.tsx
import * as React48 from "react";
var SvgPlus = (props) => /* @__PURE__ */ React48.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512",
  ...props
}, /* @__PURE__ */ React48.createElement("path", {
  fill: "currentColor",
  d: "M432 256c0 13.3-10.7 24-24 24H248v160c0 13.25-10.75 24.01-24 24.01S200 453.3 200 440V280H40c-13.25 0-24-10.74-24-23.99C16 242.8 26.75 232 40 232h160V72c0-13.25 10.75-23.99 24-23.99S248 58.75 248 72v160h160c13.3 0 24 10.8 24 24z"
}));
var Plus_default = SvgPlus;

// icons/ReturnArrow.tsx
import * as React49 from "react";
var SvgReturnArrow = (props) => /* @__PURE__ */ React49.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  ...props
}, /* @__PURE__ */ React49.createElement("path", {
  d: "M496 48v144c0 17.69-14.31 32-32 32H320c-17.69 0-32-14.31-32-32s14.31-32 32-32h63.39c-29.97-39.7-77.25-63.78-127.6-63.78C167.7 96.22 96 167.9 96 256s71.69 159.8 159.8 159.8c34.88 0 68.03-11.03 95.88-31.94 14.22-10.53 34.22-7.75 44.81 6.375 10.59 14.16 7.75 34.22-6.375 44.81-39.03 29.28-85.36 44.86-134.2 44.86C132.5 479.9 32 379.4 32 256S132.5 32.1 255.9 32.1c69.15 0 134 32.47 176.1 86.12V48c0-17.69 14.31-32 32-32s32 14.31 32 32z"
}));
var ReturnArrow_default = SvgReturnArrow;

// icons/Row.tsx
import * as React50 from "react";
var SvgRow = (props) => /* @__PURE__ */ React50.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  ...props
}, /* @__PURE__ */ React50.createElement("path", {
  d: "M8 128h432c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8H8c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8zm496 112H72c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h432c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zm-64 144H8c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h432c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8z"
}));
var Row_default = SvgRow;

// icons/Save.tsx
import * as React51 from "react";
var SvgSave = (props) => /* @__PURE__ */ React51.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512",
  ...props
}, /* @__PURE__ */ React51.createElement("path", {
  d: "M224 256c-35.2 0-64 28.8-64 64s28.8 64 64 64 64-28.8 64-64-28.8-64-64-64zm209.1-126.9-83.9-83.9c-8.1-8.14-20.4-13.2-33.1-13.2H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V163.9c0-12.7-5.1-25-14.9-34.8zM128 80h144v80H128V80zm272 336c0 8.836-7.164 16-16 16H64c-8.836 0-16-7.164-16-16V96c0-8.838 7.164-16 16-16h16v104c0 13.25 10.75 24 24 24h192c13.3 0 24-10.7 24-24V83.88l78.25 78.25c1.15 1.07 1.75 2.67 1.75 4.17V416z"
}));
var Save_default = SvgSave;

// icons/Search.tsx
import * as React52 from "react";
var SvgSearch = (props) => /* @__PURE__ */ React52.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  ...props
}, /* @__PURE__ */ React52.createElement("path", {
  d: "M508.5 468.9 387.1 347.5c-2.3-2.3-5.3-3.5-8.5-3.5h-13.2c31.5-36.5 50.6-84 50.6-136C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c52 0 99.5-19.1 136-50.6v13.2c0 3.2 1.3 6.2 3.5 8.5l121.4 121.4c4.7 4.7 12.3 4.7 17 0l22.6-22.6c4.7-4.7 4.7-12.3 0-17zM208 368c-88.4 0-160-71.6-160-160S119.6 48 208 48s160 71.6 160 160-71.6 160-160 160z"
}));
var Search_default = SvgSearch;

// icons/ShoppingBag.tsx
import * as React53 from "react";
var SvgShoppingBag = (props) => /* @__PURE__ */ React53.createElement("svg", {
  viewBox: "0 0 14 14",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React53.createElement("path", {
  d: "M10.5 3.5C10.5 1.586 8.914 0 7 0a3.507 3.507 0 0 0-3.5 3.5H.875v8.313A2.16 2.16 0 0 0 3.062 14h7.875a2.177 2.177 0 0 0 2.188-2.188V3.5H10.5ZM7 .875c1.422 0 2.625 1.203 2.625 2.625h-5.25C4.375 2.078 5.55.875 7 .875Zm5.25 10.938c0 .738-.602 1.312-1.313 1.312H3.062a1.296 1.296 0 0 1-1.312-1.313V4.375H3.5v1.312c0 .247.191.438.437.438a.45.45 0 0 0 .438-.438V4.375h5.25v1.312c0 .247.191.438.437.438a.45.45 0 0 0 .438-.438V4.375h1.75v7.438Z"
}));
var ShoppingBag_default = SvgShoppingBag;

// icons/ShoppingBasket.tsx
import * as React54 from "react";
var SvgShoppingBasket = (props) => /* @__PURE__ */ React54.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 16",
  ...props
}, /* @__PURE__ */ React54.createElement("path", {
  d: "M18.9 7.3h-.4v.4l-1 6.4c0 .6-.6 1-1.2 1H3.7c-.6 0-1.2-.4-1.2-1l-1-6.4v-.4H.8A.4.4 0 0 1 .4 7v-.5c0-.2.2-.4.4-.4h2.6l.1-.2 3.7-5a.7.7 0 0 1 1.1.7L5.6 5.3 5 6h10l-.6-.7-2.7-3.8a.7.7 0 0 1 1-.8l3.8 5.1.1.2h2.6c.2 0 .4.2.4.4v.5c0 .3-.2.4-.4.4h-.3Zm-7.6 5.2V8.6a1.3 1.3 0 0 0-2.6 0v3.9a1.3 1.3 0 1 0 2.6 0Zm3.9 0V8.6a1.3 1.3 0 0 0-2.6 0v3.9a1.3 1.3 0 0 0 2.6 0Zm-7.8 0V8.6a1.3 1.3 0 1 0-2.6 0v3.9a1.3 1.3 0 1 0 2.6 0Z"
}));
var ShoppingBasket_default = SvgShoppingBasket;

// icons/ShoppingCart.tsx
import * as React55 from "react";
var SvgShoppingCart = (props) => /* @__PURE__ */ React55.createElement("svg", {
  viewBox: "0 0 14 13",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React55.createElement("path", {
  d: "M13.404 1.557H3.138L2.92.487C2.871.219 2.627 0 2.36 0H.293A.296.296 0 0 0 0 .292v.195c0 .17.122.291.292.291h1.897l1.703 9.074c-.243.292-.389.657-.389 1.046 0 .876.681 1.557 1.557 1.557.851 0 1.557-.68 1.557-1.556 0-.268-.097-.536-.219-.779h3.527c-.121.243-.194.51-.194.779 0 .875.68 1.556 1.557 1.556.851 0 1.557-.68 1.557-1.556 0-.414-.195-.828-.487-1.095a.573.573 0 0 0-.56-.462h-7.2l-.292-1.557h8.052c.292 0 .51-.17.584-.463l1.046-5.06a.585.585 0 0 0-.584-.705Zm-7.566 9.341a.784.784 0 0 1-.778.779.769.769 0 0 1-.778-.778c0-.414.34-.779.778-.779a.8.8 0 0 1 .778.779Zm5.45.779a.769.769 0 0 1-.779-.778c0-.414.34-.779.779-.779a.8.8 0 0 1 .778.779.784.784 0 0 1-.778.778Zm.924-4.67H4.16l-.876-4.672h9.901l-.973 4.671ZM9.61 5.181c.195-.195.049-.511-.195-.511h-.85V3.406a.314.314 0 0 0-.293-.292h-.194a.296.296 0 0 0-.292.292V4.67h-.876c-.243 0-.39.316-.195.51l1.24 1.241a.28.28 0 0 0 .414 0l1.241-1.24Z"
}));
var ShoppingCart_default = SvgShoppingCart;

// icons/SignOut.tsx
import * as React56 from "react";
var SvgSignOut = (props) => /* @__PURE__ */ React56.createElement("svg", {
  viewBox: "0 0 20 16",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React56.createElement("path", {
  d: "M1.875.5h5.156A.47.47 0 0 1 7.5.969v.312a.47.47 0 0 1-.469.469H1.875a.627.627 0 0 0-.625.625v11.25c0 .344.281.625.625.625h5.156a.47.47 0 0 1 .469.469v.312a.47.47 0 0 1-.469.469H1.875A1.875 1.875 0 0 1 0 13.625V2.375C0 1.34.84.5 1.875.5Zm10.898.762-.277.277a.47.47 0 0 0 0 .664l5.156 5.133H6.72a.47.47 0 0 0-.469.469v.39c0 .258.21.47.469.47h10.933L12.5 13.796a.47.47 0 0 0 0 .664l.277.277a.47.47 0 0 0 .664 0l6.426-6.406a.47.47 0 0 0 0-.664l-6.43-6.406a.47.47 0 0 0-.664 0Z"
}));
var SignOut_default = SvgSignOut;

// icons/Sliders.tsx
import * as React57 from "react";
var SvgSliders = (props) => /* @__PURE__ */ React57.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  ...props
}, /* @__PURE__ */ React57.createElement("path", {
  d: "M0 416c0-17.7 14.33-32 32-32h54.66C99 355.7 127.2 336 160 336c32.8 0 60.1 19.7 73.3 48H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H233.3c-13.2 28.3-40.5 48-73.3 48s-61-19.7-73.34-48H32c-17.67 0-32-14.3-32-32zm192 0c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.3 32-32zm160-240c32.8 0 60.1 19.7 73.3 48H480c17.7 0 32 14.3 32 32s-14.3 32-32 32h-54.7c-13.2 28.3-40.5 48-73.3 48s-61-19.7-73.3-48H32c-17.67 0-32-14.3-32-32s14.33-32 32-32h246.7c12.3-28.3 40.5-48 73.3-48zm32 80c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.3 32-32zm96-192c17.7 0 32 14.33 32 32 0 17.7-14.3 32-32 32H265.3c-13.2 28.3-40.5 48-73.3 48s-61-19.7-73.3-48H32c-17.67 0-32-14.3-32-32 0-17.67 14.33-32 32-32h86.7C131 35.75 159.2 16 192 16s60.1 19.75 73.3 48H480zM160 96c0 17.7 14.3 32 32 32s32-14.3 32-32c0-17.67-14.3-32-32-32s-32 14.33-32 32z"
}));
var Sliders_default = SvgSliders;

// icons/Sparkles.tsx
import * as React58 from "react";
var SvgSparkles = (props) => /* @__PURE__ */ React58.createElement("svg", {
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React58.createElement("path", {
  d: "m10.25 3.437 1.531.782.75 1.5c.094.156.25.28.469.28.187 0 .344-.124.437-.28l.75-1.5 1.532-.782a.49.49 0 0 0 .28-.437.49.49 0 0 0-.28-.438l-1.532-.78-.75-1.5c-.187-.345-.718-.345-.906 0l-.75 1.5-1.531.78A.49.49 0 0 0 9.969 3a.49.49 0 0 0 .28.437Zm2.125-.843a.378.378 0 0 0 .219-.22l.406-.75.375.75a.378.378 0 0 0 .219.22l.78.406-.78.375c-.094.062-.188.125-.22.219l-.374.78-.406-.78c-.032-.094-.125-.157-.22-.22L11.595 3l.78-.406Zm3.344 9.968-1.532-.75-.75-1.53c-.187-.345-.718-.345-.906 0l-.75 1.53-1.531.75c-.156.094-.281.25-.281.438a.54.54 0 0 0 .28.469l1.532.75.75 1.53c.094.157.25.25.469.25a.499.499 0 0 0 .437-.25l.75-1.53 1.532-.75a.54.54 0 0 0 .28-.47c0-.187-.124-.343-.28-.437Zm-2.125.844a.377.377 0 0 0-.22.219l-.374.781-.406-.781a.377.377 0 0 0-.22-.219l-.78-.406.78-.375c.095-.063.188-.125.22-.219l.406-.781.375.781c.031.094.125.156.219.219l.78.375-.78.406ZM12 8c-.031-.188-.125-.375-.281-.438l-3.532-1.78-1.75-3.5c-.187-.345-.718-.345-.906 0l-1.75 3.5L.25 7.561A.49.49 0 0 0-.031 8a.49.49 0 0 0 .28.437l3.532 1.782 1.75 3.53c.094.157.25.25.469.25a.499.499 0 0 0 .437-.25l1.75-3.53 3.532-1.782c.156-.062.25-.25.28-.437ZM7.594 9.406a.377.377 0 0 0-.22.219L6 12.406 4.594 9.625a.377.377 0 0 0-.22-.219L1.595 8l2.78-1.375c.095-.063.188-.125.22-.219L6 3.625l1.375 2.781c.031.094.125.156.219.219L10.374 8l-2.78 1.406Z"
}));
var Sparkles_default = SvgSparkles;

// icons/Spinner.tsx
import * as React59 from "react";
var SvgSpinner = (props) => /* @__PURE__ */ React59.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 40",
  ...props
}, /* @__PURE__ */ React59.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 16.5,
  fill: "none",
  stroke: "#CCC",
  strokeWidth: 7
}), /* @__PURE__ */ React59.createElement("path", {
  fill: "#07B8BA",
  d: "M19.851 7.5a3.75 3.75 0 0 0 .942-7.381 20.145 20.145 0 0 0-1.322-.1 3.75 3.75 0 0 0 .38 7.48Z"
}));
var Spinner_default = SvgSpinner;

// icons/StarFull.tsx
import * as React60 from "react";
var SvgStarFull = (props) => /* @__PURE__ */ React60.createElement("svg", {
  viewBox: "0 0 14 14",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React60.createElement("path", {
  d: "M6.302 1.21 4.715 4.428l-3.55.518a.778.778 0 0 0-.431 1.327l2.57 2.504-.609 3.536a.777.777 0 0 0 1.128.82L7 11.462l3.177 1.67a.778.778 0 0 0 1.128-.82l-.608-3.536 2.569-2.504a.778.778 0 0 0-.43-1.327l-3.551-.518L7.698 1.21a.778.778 0 0 0-1.396 0Z"
}));
var StarFull_default = SvgStarFull;

// icons/StarHalf.tsx
import * as React61 from "react";
var SvgStarHalf = (props) => /* @__PURE__ */ React61.createElement("svg", {
  viewBox: "0 0 14 14",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React61.createElement("path", {
  d: "M13.283 4.793 9.46 4.237 7.75.779A.832.832 0 0 0 7 .313a.826.826 0 0 0-.75.466L4.54 4.236l-3.823.556a.836.836 0 0 0-.463 1.426l2.765 2.69-.654 3.8a.838.838 0 0 0 1.214.88l3.42-1.793 3.42 1.794a.837.837 0 0 0 1.214-.88l-.653-3.8 2.766-2.69a.836.836 0 0 0-.463-1.426Zm-3.18 3.218-.473.46.112.65.51 2.963-2.668-1.4-.585-.306L7 2.093l1.333 2.698.292.591.653.095 2.984.435-2.159 2.1Z"
}));
var StarHalf_default = SvgStarHalf;

// icons/Star.tsx
import * as React62 from "react";
var SvgStar = (props) => /* @__PURE__ */ React62.createElement("svg", {
  viewBox: "0 0 14 14",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React62.createElement("path", {
  d: "m5.047 4.885-.26.038-3.55.518h-.001a.278.278 0 0 0-.153.474l2.57 2.504.187.183-.044.26-.608 3.536a.277.277 0 0 0 .401.293l.002-.001 3.176-1.67.233-.122.233.122 3.176 1.67a.278.278 0 0 0 .403-.292l-.608-3.537-.044-.259.188-.183 2.569-2.504a.278.278 0 0 0-.153-.474l-3.551-.518-.26-.038-.117-.235L7.25 1.432a.278.278 0 0 0-.5 0L5.048 4.885Zm0 0 .117-.235L6.75 1.432 5.047 4.885Z",
  stroke: "#000"
}));
var Star_default = SvgStar;

// icons/Tachometer.tsx
import * as React63 from "react";
var SvgTachometer = (props) => /* @__PURE__ */ React63.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 576 512",
  ...props
}, /* @__PURE__ */ React63.createElement("path", {
  d: "M288 32C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm0 64c14.71 0 26.58 10.13 30.32 23.65-1.11 2.26-2.64 4.23-3.45 6.67l-9.22 27.67c-5.13 3.49-10.97 6.01-17.64 6.01-17.67 0-32-14.33-32-32S270.33 96 288 96zM96 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm48-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm246.77-72.41-61.33 184C343.13 347.33 352 364.54 352 384c0 11.72-3.38 22.55-8.88 32H232.88c-5.5-9.45-8.88-20.28-8.88-32 0-33.94 26.5-61.43 59.9-63.59l61.34-184.01c4.17-12.56 17.73-19.45 30.36-15.17 12.57 4.19 19.35 17.79 15.17 30.36zm14.66 57.2 15.52-46.55c3.47-1.29 7.13-2.23 11.05-2.23 17.67 0 32 14.33 32 32s-14.33 32-32 32c-11.38-.01-20.89-6.28-26.57-15.22zM480 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
}));
var Tachometer_default = SvgTachometer;

// icons/Tag.tsx
import * as React64 from "react";
var SvgTag = (props) => /* @__PURE__ */ React64.createElement("svg", {
  viewBox: "0 0 14 14",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React64.createElement("path", {
  d: "M13.583 6.177 7.816.41A1.328 1.328 0 0 0 6.887 0H1.312C.574 0 0 .601 0 1.312v5.603c0 .355.137.683.383.929l5.766 5.767c.52.519 1.367.519 1.859 0l5.575-5.576c.52-.492.52-1.339 0-1.858Zm-.601 1.257-5.575 5.575c-.192.164-.465.164-.63 0L.985 7.215a.439.439 0 0 1-.137-.3h.028V1.312a.45.45 0 0 1 .437-.437h5.575c.11 0 .219.054.3.136l5.795 5.794c.164.164.164.438 0 .629ZM3.936 3.389c.3 0 .546.246.546.547a.531.531 0 0 1-.546.546c-.328 0-.547-.218-.547-.546 0-.301.219-.547.547-.547Zm0-.765c-.738 0-1.312.601-1.312 1.312 0 .737.574 1.311 1.312 1.311.71 0 1.311-.574 1.311-1.311a1.33 1.33 0 0 0-1.311-1.312Z"
}));
var Tag_default = SvgTag;

// icons/TimesCircle.tsx
import * as React65 from "react";
var SvgTimesCircle = (props) => /* @__PURE__ */ React65.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  ...props
}, /* @__PURE__ */ React65.createElement("path", {
  d: "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 464c-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216zm94.8-285.3L281.5 256l69.3 69.3c4.7 4.7 4.7 12.3 0 17l-8.5 8.5c-4.7 4.7-12.3 4.7-17 0L256 281.5l-69.3 69.3c-4.7 4.7-12.3 4.7-17 0l-8.5-8.5c-4.7-4.7-4.7-12.3 0-17l69.3-69.3-69.3-69.3c-4.7-4.7-4.7-12.3 0-17l8.5-8.5c4.7-4.7 12.3-4.7 17 0l69.3 69.3 69.3-69.3c4.7-4.7 12.3-4.7 17 0l8.5 8.5c4.6 4.7 4.6 12.3 0 17z"
}));
var TimesCircle_default = SvgTimesCircle;

// icons/Times.tsx
import * as React66 from "react";
var SvgTimes = (props) => /* @__PURE__ */ React66.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 320 512",
  ...props
}, /* @__PURE__ */ React66.createElement("path", {
  d: "M193.94 256 296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z"
}));
var Times_default = SvgTimes;

// icons/Upload.tsx
import * as React67 from "react";
var SvgUpload = (props) => /* @__PURE__ */ React67.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 384 512",
  ...props
}, /* @__PURE__ */ React67.createElement("path", {
  d: "M256 0v128h128L256 0zm-32 128V0H48C21.49 0 0 21.49 0 48v416c0 26.5 21.49 48 48 48h288c26.51 0 48-21.49 48-48V160H256.9c-18.6 0-32.9-14.3-32.9-32zm64.1 216.1c-3.8 5.6-9.9 7.9-16.1 7.9s-12.28-2.344-16.97-7.031L216 305.9V408c0 13.25-10.75 24-24 24s-24-10.75-24-24V305.9l-39.03 39.03c-9.375 9.375-24.56 9.375-33.94 0s-9.375-24.56 0-33.94l80-80c9.375-9.375 24.56-9.375 33.94 0l80 80c9.33 9.41 9.33 24.61-.87 33.11z"
}));
var Upload_default = SvgUpload;

// icons/UserFriends.tsx
import * as React68 from "react";
var SvgUserFriends = (props) => /* @__PURE__ */ React68.createElement("svg", {
  viewBox: "0 0 16 11",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React68.createElement("path", {
  d: "M11.95 5.5a2.25 2.25 0 1 0 0-4.501 2.25 2.25 0 0 0 0 4.501Zm0-3.75c.82 0 1.5.68 1.5 1.5 0 .844-.68 1.5-1.5 1.5a1.48 1.48 0 0 1-1.5-1.5c0-.82.656-1.5 1.5-1.5ZM5.2 5.5a2.636 2.636 0 0 0 2.625-2.625C7.825 1.445 6.63.25 5.2.25a2.636 2.636 0 0 0-2.625 2.625A2.62 2.62 0 0 0 5.2 5.5Zm0-4.5a1.88 1.88 0 0 1 1.875 1.875A1.866 1.866 0 0 1 5.2 4.75a1.851 1.851 0 0 1-1.875-1.875C3.325 1.844 4.145 1 5.2 1ZM7.075 5.97c-.797 0-.984.281-1.875.281-.914 0-1.101-.281-1.898-.281-.844 0-1.664.398-2.156 1.101C.864 7.516.7 8.031.7 8.594v1.031a1.11 1.11 0 0 0 1.125 1.125h6.75c.61 0 1.125-.492 1.125-1.125V8.594c0-.563-.187-1.078-.469-1.524A2.633 2.633 0 0 0 7.075 5.97ZM8.95 9.625c0 .211-.187.375-.375.375h-6.75a.37.37 0 0 1-.375-.375V8.594c0-.399.094-.774.328-1.102.305-.468.89-.773 1.524-.773.656 0 .89.281 1.898.281S6.42 6.72 7.075 6.72c.633 0 1.219.305 1.524.773.234.328.328.703.328 1.102v1.031h.023Zm6.352-2.672c-.399-.61-1.078-.937-1.805-.937-.633 0-.797.234-1.547.234-.75 0-.914-.234-1.57-.234-.305 0-.61.07-.89.21.35.352.421.54.468.61.14-.023.258-.047.422-.047.515 0 .703.235 1.57.235.844 0 1.055-.235 1.547-.235s.938.211 1.195.586c.164.234.258.516.258.82v.868a.185.185 0 0 1-.187.187H10.45c0 .422 0 .54-.047.75h4.36a.925.925 0 0 0 .937-.937v-.868c0-.468-.14-.89-.398-1.242Z"
}));
var UserFriends_default = SvgUserFriends;

// icons/UserSolid.tsx
import * as React69 from "react";
var SvgUserSolid = (props) => /* @__PURE__ */ React69.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512",
  ...props
}, /* @__PURE__ */ React69.createElement("path", {
  d: "M224 256a128 128 0 1 0 0-256 128 128 0 0 0 0 256zm50.7 48H173.3A173.3 173.3 0 0 0 0 477.3 34.7 34.7 0 0 0 34.7 512h378.7a34.6 34.6 0 0 0 34.6-34.7c0-95.7-77.6-173.3-173.3-173.3z"
}));
var UserSolid_default = SvgUserSolid;

// icons/User.tsx
import * as React70 from "react";
var SvgUser = (props) => /* @__PURE__ */ React70.createElement("svg", {
  viewBox: "0 0 14 16",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React70.createElement("path", {
  d: "M9.781 9C8.875 9 8.47 9.5 7 9.5 5.5 9.5 5.094 9 4.187 9 1.875 9 0 10.906 0 13.219v1.28c0 .845.656 1.5 1.5 1.5h11a1.5 1.5 0 0 0 1.5-1.5v-1.28c0-2.313-1.906-4.22-4.219-4.22ZM13 14.5c0 .281-.25.5-.5.5h-11a.494.494 0 0 1-.5-.5v-1.281c0-1.782 1.406-3.22 3.187-3.22.625 0 1.22.5 2.813.5 1.562 0 2.187-.5 2.781-.5A3.214 3.214 0 0 1 13 13.22v1.28ZM7 8c2.187 0 4-1.781 4-4 0-2.188-1.813-4-4-4C4.78 0 3 1.812 3 4 3 6.219 4.78 8 7 8Zm0-7c1.625 0 3 1.375 3 3 0 1.656-1.375 3-3 3a3 3 0 0 1-3-3c0-1.625 1.344-3 3-3Z"
}));
var User_default = SvgUser;

// icons/Users.tsx
import * as React71 from "react";
var SvgUsers = (props) => /* @__PURE__ */ React71.createElement("svg", {
  viewBox: "0 0 15 11",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React71.createElement("path", {
  d: "M12.75 4.75c1.031 0 1.875-.82 1.875-1.875A1.88 1.88 0 0 0 12.75 1a1.866 1.866 0 0 0-1.875 1.875c0 1.055.82 1.875 1.875 1.875Zm0-3c.61 0 1.125.516 1.125 1.125 0 .633-.516 1.125-1.125 1.125a1.11 1.11 0 0 1-1.125-1.125c0-.61.492-1.125 1.125-1.125ZM7.5 5.5a2.636 2.636 0 0 0 2.625-2.625C10.125 1.445 8.93.25 7.5.25a2.636 2.636 0 0 0-2.625 2.625A2.62 2.62 0 0 0 7.5 5.5Zm0-4.5a1.88 1.88 0 0 1 1.875 1.875A1.866 1.866 0 0 1 7.5 4.75a1.851 1.851 0 0 1-1.875-1.875C5.625 1.844 6.445 1 7.5 1Zm5.719 4.5h-.938c-.375 0-.703.117-.984.305.234.164.422.328.61.539.116-.047.234-.094.374-.094h.938c.562 0 1.031.516 1.031 1.125 0 .21.164.375.375.375A.385.385 0 0 0 15 7.375c0-1.031-.82-1.875-1.781-1.875ZM2.25 4.75c1.031 0 1.875-.82 1.875-1.875A1.88 1.88 0 0 0 2.25 1 1.866 1.866 0 0 0 .375 2.875c0 1.055.82 1.875 1.875 1.875Zm0-3c.61 0 1.125.516 1.125 1.125C3.375 3.508 2.859 4 2.25 4a1.11 1.11 0 0 1-1.125-1.125c0-.61.492-1.125 1.125-1.125Zm7.125 4.219c-.797 0-.984.281-1.875.281-.914 0-1.102-.281-1.898-.281-.844 0-1.665.398-2.157 1.101-.28.446-.445.961-.445 1.524v1.031a1.11 1.11 0 0 0 1.125 1.125h6.75c.61 0 1.125-.492 1.125-1.125V8.594c0-.563-.188-1.078-.469-1.524A2.633 2.633 0 0 0 9.375 5.97Zm1.875 3.656c0 .21-.188.375-.375.375h-6.75a.37.37 0 0 1-.375-.375V8.594c0-.399.094-.774.328-1.102.305-.469.89-.773 1.524-.773.656 0 .89.281 1.898.281s1.219-.281 1.875-.281c.633 0 1.219.304 1.523.773.235.328.329.703.329 1.102v1.031h.023Zm-7.57-3.82a1.731 1.731 0 0 0-.961-.305H1.78C.797 5.5 0 6.344 0 7.375c0 .21.164.375.375.375a.385.385 0 0 0 .375-.375c0-.61.445-1.125 1.031-1.125h.938c.117 0 .234.047.351.094.188-.211.375-.375.61-.54Z"
}));
var Users_default = SvgUsers;

// icons/Utensils.tsx
import * as React72 from "react";
var SvgUtensils = (props) => /* @__PURE__ */ React72.createElement("svg", {
  viewBox: "0 0 12 14",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React72.createElement("path", {
  d: "M8.156 12.879c-.048.629.403 1.121.948 1.121h1.328c.521 0 .948-.465.948-1.04V1.067C11.38.492 10.953 0 10.432 0 8.914 0 6.828 2.242 6.804 4.813c0 1.449.688 2.652 1.684 3.554l-.332 4.512Zm-.57-8.066c0-2.133 1.779-3.938 2.846-3.938.095 0 .19.082.19.191v11.895c0 .082-.095.164-.19.164H9.104c-.119 0-.213-.082-.19-.164l.356-5.004c-.925-.793-1.683-1.75-1.683-3.144ZM5.69.93A1.07 1.07 0 0 0 4.6 0c-.285 0-.57.11-.783.328C3.604.137 3.343 0 3.035 0c-.332 0-.593.137-.806.328A1.09 1.09 0 0 0 1.446 0C.854 0 .426.41.356.93.308 1.203 0 3.254 0 4.102c0 1.394.616 2.515 1.683 3.035l-.284 5.77c-.024.6.38 1.093.924 1.093h1.423c.522 0 .925-.492.9-1.094l-.26-5.77c1.043-.519 1.683-1.64 1.683-3.034 0-.848-.332-2.899-.379-3.172ZM3.604 6.563l.284 6.398c0 .082-.071.164-.142.164H2.323a.169.169 0 0 1-.166-.164l.285-6.399C1.446 6.345.759 5.388.759 4.103c0-.793.332-3.008.332-3.008.047-.274.687-.274.71 0V4.43c.025.328.665.328.688.027l.19-3.363c.024-.274.664-.274.688 0l.19 3.363c.023.3.663.3.687-.027V1.094c.024-.274.664-.274.711 0 0 0 .332 2.215.332 3.008.024 1.285-.688 2.242-1.683 2.46Z"
}));
var Utensils_default = SvgUtensils;

// icons/VolumeHigh.tsx
import * as React73 from "react";
var SvgVolumeHigh = (props) => /* @__PURE__ */ React73.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 512",
  ...props
}, /* @__PURE__ */ React73.createElement("path", {
  d: "M412.6 182c-10.28-8.334-25.41-6.867-33.75 3.402-8.406 10.24-6.906 25.35 3.375 33.74C393.5 228.4 400 241.8 400 255.1c0 14.17-6.5 27.59-17.81 36.83-10.28 8.396-11.78 23.5-3.375 33.74 4.719 5.806 11.62 8.802 18.56 8.802 5.344 0 10.75-1.779 15.19-5.399C435.1 311.5 448 284.6 448 255.1s-12.9-54.7-35.4-73.1zm60.5-73.8c-10.22-8.334-25.34-6.898-33.78 3.34-8.406 10.24-6.906 25.35 3.344 33.74C476.6 172.1 496 213.3 496 255.1s-19.44 82.1-53.31 110.7c-10.25 8.396-11.75 23.5-3.344 33.74a23.962 23.962 0 0 0 18.56 8.771c5.375 0 10.75-1.779 15.22-5.431C518.2 366.9 544 313 544 255.1S518.2 145 473.1 108.2zm61.3-74.8c-10.22-8.334-25.34-6.867-33.78 3.34-8.406 10.24-6.906 25.35 3.344 33.74C559.9 116.3 592 183.9 592 255.1s-32.09 139.7-88.06 185.5c-10.25 8.396-11.75 23.5-3.344 33.74C505.3 481 512.2 484 519.2 484c5.375 0 10.75-1.779 15.22-5.431C601.5 423.6 640 342.5 640 255.1S601.5 88.34 534.4 33.4zm-233.2 1.58c-11.5-5.181-25.01-3.076-34.43 5.29L131.8 160.1H48c-26.51 0-48 21.48-48 47.96v95.92c0 26.48 21.49 47.96 48 47.96h83.84l134.9 119.8A32.167 32.167 0 0 0 288 479.8c4.438 0 8.959-.931 13.16-2.835A31.81 31.81 0 0 0 320 447.9V64.12c0-12.57-7.3-23.99-18.8-29.14z"
}));
var VolumeHigh_default = SvgVolumeHigh;

// icons/WarningTriangle.tsx
import * as React74 from "react";
var SvgWarningTriangle = (props) => /* @__PURE__ */ React74.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  ...props
}, /* @__PURE__ */ React74.createElement("path", {
  d: "M256 32a40 40 0 0 1 34.5 19.8l216 368A40 40 0 0 1 472 480H40a40 40 0 0 1-34.5-60.2l216-368A40 40 0 0 1 256 32zm0 128a24 24 0 0 0-24 24v112a24 24 0 1 0 48 0V184a24 24 0 0 0-24-24zm32 224a32 32 0 1 0-64 0 32 32 0 0 0 64 0z"
}));
var WarningTriangle_default = SvgWarningTriangle;

// icons/Warning.tsx
import * as React75 from "react";
var SvgWarning = (props) => /* @__PURE__ */ React75.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  ...props
}, /* @__PURE__ */ React75.createElement("path", {
  d: "M504 256c0 137-111.04 248-248 248S8 393 8 256C8 119.08 119.04 8 256 8s248 111.08 248 248zm-248 50a46 46 0 1 0 0 92 46 46 0 0 0 0-92zm-43.67-165.35 7.41 136a12 12 0 0 0 12 11.35h48.54a12 12 0 0 0 11.99-11.35l7.41-136A12 12 0 0 0 287.7 128h-63.38a12 12 0 0 0-11.98 12.65z"
}));
var Warning_default = SvgWarning;

// index.ts
var iconBaseProps = {
  fill: "currentColor",
  "aria-hidden": true,
  focusable: false
};
export {
  AlignLeft_default as AlignLeft,
  Bell_default as Bell,
  BrokenLink_default as BrokenLink,
  Calendar_default as Calendar,
  CartCircle_default as CartCircle,
  Chart_default as Chart,
  Check_default as Check,
  CheckCircle_default as CheckCircle,
  ChevronDown_default as ChevronDown,
  ChevronLeft_default as ChevronLeft,
  ChevronRight_default as ChevronRight,
  ChevronUp_default as ChevronUp,
  Clock_default as Clock,
  Coins_default as Coins,
  Column_default as Column,
  Copy_default as Copy,
  CreditCard_default as CreditCard,
  Crosshair_default as Crosshair,
  Delete_default as Delete,
  DollarSign_default as DollarSign,
  Download_default as Download,
  DragIcon_default as DragIcon,
  Edit_default as Edit,
  EllipsisVertical_default as EllipsisVertical,
  Eye_default as Eye,
  EyeSlash_default as EyeSlash,
  File_default as File,
  FileInvoiceDollar_default as FileInvoiceDollar,
  FrenchFries_default as FrenchFries,
  Gear_default as Gear,
  Gift_default as Gift,
  Globe_default as Globe,
  HamburgerMenu_default as HamburgerMenu,
  Home_default as Home,
  InfoCircle_default as InfoCircle,
  Link_default as Link,
  List_default as List,
  LocationArrow_default as LocationArrow,
  Lock_default as Lock,
  Mail_default as Mail,
  MapMarker_default as MapMarker,
  MapMarkerSolid_default as MapMarkerSolid,
  Megaphone_default as Megaphone,
  Minus_default as Minus,
  Phone_default as Phone,
  Pizza_default as Pizza,
  Plus_default as Plus,
  PlusCircle_default as PlusCircle,
  ReturnArrow_default as ReturnArrow,
  Row_default as Row,
  Save_default as Save,
  Search_default as Search,
  ShoppingBag_default as ShoppingBag,
  ShoppingBasket_default as ShoppingBasket,
  ShoppingCart_default as ShoppingCart,
  SignOut_default as SignOut,
  Sliders_default as Sliders,
  Sparkles_default as Sparkles,
  Spinner_default as Spinner,
  Star_default as Star,
  StarFull_default as StarFull,
  StarHalf_default as StarHalf,
  Tachometer_default as Tachometer,
  Tag_default as Tag,
  Times_default as Times,
  TimesCircle_default as TimesCircle,
  Upload_default as Upload,
  User_default as User,
  UserFriends_default as UserFriends,
  UserSolid_default as UserSolid,
  Users_default as Users,
  Utensils_default as Utensils,
  VolumeHigh_default as VolumeHigh,
  Warning_default as Warning,
  WarningTriangle_default as WarningTriangle,
  iconBaseProps
};
